module.exports = __webpack_public_path__ + "static/media/jpg.7d3eb65b.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/jpg.png
// module id = 76
// module chunks = 0